/* ═══════════════════════════════════════════════════════════
   js/components/jk-compare.js — Phase 4C
   Контроллер кнопки «В сравнение» (#jkCompareBtn).
   Читает/пишет localStorage ключ 'bronidom_compare' (JSON-массив),
   синхронизирует aria-pressed и метку на DOM.
   Также регистрирует Custom Element <jk-compare-counter>,
   который показывает счётчик «N в сравнении» и обновляется на события.
   ═══════════════════════════════════════════════════════════ */
(() => {
    'use strict';

    const STORAGE_KEY = 'bronidom_compare';
    const MAX_ITEMS = 5;
    const EVENT_CHANGE = 'bronidom:compare-change';

    function readList() {
        try {
            const raw = localStorage.getItem(STORAGE_KEY);
            if (!raw) return [];
            const parsed = JSON.parse(raw);
            return Array.isArray(parsed) ? parsed : [];
        } catch (_e) {
            return [];
        }
    }

    function writeList(list) {
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_ITEMS)));
        } catch (_e) { /* quota or private mode */ }
    }

    function hasItem(list, id) {
        const nId = Number(id);
        return list.some(x => x && Number(x.id) === nId);
    }

    function toggleItem(list, id, name) {
        const nId = Number(id);
        if (!Number.isFinite(nId) || nId <= 0) return list;
        if (hasItem(list, nId)) {
            return list.filter(x => x && Number(x.id) !== nId);
        }
        const next = list.slice();
        if (next.length >= MAX_ITEMS) next.shift();
        next.push({ id: nId, name: String(name || ''), ts: Date.now() });
        return next;
    }

    function dispatchChange() {
        try {
            window.dispatchEvent(new CustomEvent(EVENT_CHANGE, { detail: { count: readList().length } }));
        } catch (_e) { /* old browsers */ }
    }

    function syncButton(btn) {
        if (!btn) return;
        const id = btn.getAttribute('data-jk-id');
        const pressed = hasItem(readList(), id);
        btn.setAttribute('aria-pressed', pressed ? 'true' : 'false');
        btn.classList.toggle('is-active', pressed);
        const label = btn.querySelector('.jk-btn-compare__label');
        if (label) {
            label.textContent = pressed ? 'В сравнении' : 'В сравнение';
        }
        btn.setAttribute('aria-label', pressed ? 'Убрать из сравнения' : 'Добавить в сравнение');
    }

    function initButton(btn) {
        if (!btn || btn.dataset.jkCompareReady === '1') return;
        btn.dataset.jkCompareReady = '1';

        syncButton(btn);

        btn.addEventListener('click', () => {
            const id = btn.getAttribute('data-jk-id');
            const name = btn.getAttribute('data-jk-name') || '';
            const next = toggleItem(readList(), id, name);
            writeList(next);
            syncButton(btn);
            dispatchChange();
            if (typeof window.ymGoal === 'function') {
                window.ymGoal('jk_compare_toggle');
            }
        });

        window.addEventListener(EVENT_CHANGE, () => syncButton(btn));
    }

    function initAll() {
        const btns = document.querySelectorAll('.jk-btn-compare');
        btns.forEach(initButton);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAll);
    } else {
        initAll();
    }

    /* ── Custom Element <jk-compare-counter> ── */
    if (typeof customElements !== 'undefined' && !customElements.get('jk-compare-counter')) {
        class JkCompareCounter extends HTMLElement {
            connectedCallback() {
                this._onChange = () => this._render();
                window.addEventListener(EVENT_CHANGE, this._onChange);
                this._render();
            }
            disconnectedCallback() {
                window.removeEventListener(EVENT_CHANGE, this._onChange);
            }
            _render() {
                const n = readList().length;
                this.textContent = n > 0 ? String(n) : '';
                this.setAttribute('data-count', String(n));
                this.hidden = n === 0;
            }
        }
        customElements.define('jk-compare-counter', JkCompareCounter);
    }

    /* ── Экспорт для тестов (порт логики без DOM) ── */
    if (typeof window !== 'undefined') {
        window.__jkCompare = Object.freeze({
            STORAGE_KEY,
            MAX_ITEMS,
            EVENT_CHANGE,
            readList,
            writeList,
            hasItem,
            toggleItem,
        });
    }
})();
